import {gsap} from "gsap";
import {SplitText} from "gsap/SplitText";
import scrollTrigger from "gsap/ScrollTrigger";

const animTransform = () => {
        const elAnimated = $('.block-animate-transform');
        if (elAnimated.length >= 1) {
            const stringToBoolean = (string) => string === 'false' ? false : !!string
            $(window).on('load', function () {
                if (window.innerWidth > 768) {
                    gsap.registerPlugin(scrollTrigger);
                    elAnimated.each(function () {
                        let thisEl = $(this),
                            objScrollTrigger = {},
                            objFromVars = {},
                            objToVars = {};
                        //Animate on Scroll
                        if (stringToBoolean(thisEl.attr('data-on-scroll'))) {
                            objScrollTrigger = {
                                scrollTrigger: {
                                    trigger: thisEl,
                                    // markers: true,
                                    start: "top center",
                                    end: 'bottom top',
                                },
                            }
                            thisEl.attr('data-scrub') ? objScrollTrigger.scrollTrigger['scrub'] = Number(thisEl.attr('data-scrub')) : null;
                            thisEl.attr('data-start') ? objScrollTrigger.scrollTrigger['start'] = thisEl.attr('data-start') : null;
                            thisEl.attr('data-end') ? objScrollTrigger.scrollTrigger['end'] = thisEl.attr('data-end') : null;
                        }
                        //Style from start animate
                        thisEl.attr('data-from-x') ? objFromVars['x'] = Number(thisEl.attr('data-from-x')) : null;
                        thisEl.attr('data-from-y') ? objFromVars['y'] = Number(thisEl.attr('data-from-y')) : null;
                        thisEl.attr('data-from-transform') ? objFromVars['transform'] = thisEl.attr('data-from-transform') : null;
                        thisEl.attr('data-from-rotate') ? objFromVars['rotate'] = Number(thisEl.attr('data-from-rotate')) : null;
                        thisEl.attr('data-from-opacity') ? objFromVars['opacity'] = Number(thisEl.attr('data-from-opacity')) : null;
                        thisEl.attr('data-from-scale') ? objFromVars['scale'] = Number(thisEl.attr('data-from-scale')) : null;
                        //Style to end animate
                        thisEl.attr('data-to-x') ? objToVars['x'] = Number(thisEl.attr('data-to-x')) : null;
                        thisEl.attr('data-to-y') ? objToVars['y'] = Number(thisEl.attr('data-to-y')) : null;
                        thisEl.attr('data-to-max-width') ? objToVars['maxWidth'] = thisEl.attr('data-to-max-width') : null;
                        thisEl.attr('data-to-transform') ? objToVars['transform'] = thisEl.attr('data-to-transform') : null;
                        thisEl.attr('data-to-scale') ? objToVars['scale'] = Number(thisEl.attr('data-to-scale')) : null;
                        thisEl.attr('data-to-rotate') ? objToVars['rotate'] = Number(thisEl.attr('data-to-rotate')) : null;
                        thisEl.attr('data-to-opacity') ? objToVars['opacity'] = Number(thisEl.attr('data-to-opacity')) : null;
                        thisEl.attr('data-duration') ? objToVars['duration'] = Number(thisEl.attr('data-duration')) : objToVars['duration'] = 1;
                        thisEl.attr('data-transition') ? objToVars['ease'] = thisEl.attr('data-transition') : null;
                        thisEl.attr('data-delay') ? objToVars['delay'] = Number(thisEl.attr('data-delay')) : null;
                        if (stringToBoolean(thisEl.attr('data-split-chars'))) {
                            //Add each word parent block
                            if (stringToBoolean(thisEl.attr('data-add-parent-split-words'))) {
                                new SplitText(thisEl, {type: "words", wordsClass: "parent-block-anim"});
                            }
                            const splitTypingText = new SplitText(thisEl, {type: "chars", charsClass: "wrapped-symbol"});
                            //Animate text by chars from end
                            if(stringToBoolean(thisEl.attr('data-text-from-end'))) {
                                $(thisEl.find('.parent-block-anim')).each(function (inx, el) {
                                    const slitTextForFromEnd = new SplitText(el, {type: "chars", charsClass: "wrapped-symbol"});
                                    objToVars['autoAlpha'] = 0;
                                    objToVars['stagger'] = {
                                        each: thisEl.attr('data-each') ? Number(thisEl.attr('data-each')) : 0.3,
                                        from: 'end',
                                    };
                                    if (stringToBoolean(thisEl.attr('data-delay-each-words'))) {
                                        let index = inx + 1,
                                            delayEachWord = thisEl.attr('data-delay-word-' + index),
                                            durationEachWord = thisEl.attr('data-duration-word-' + index);
                                        delayEachWord ? objToVars['delay'] = Number(delayEachWord) : null;
                                        durationEachWord ? objToVars['duration'] = Number(durationEachWord) : null;
                                    }
                                    gsap.timeline(objScrollTrigger).from(slitTextForFromEnd.chars, objToVars);
                                });
                            } else {
                                //Default animate by chars
                                objToVars['autoAlpha'] = 0;
                                objToVars['stagger'] = {
                                    each: thisEl.attr('data-each') ? Number(thisEl.attr('data-each')) : 0.3,
                                };
                                gsap.timeline(objScrollTrigger).from(splitTypingText.chars, objToVars);
                            }
                        } else if (stringToBoolean(thisEl.attr('data-split-words'))) {
                            //Add each word parent block
                            if (stringToBoolean(thisEl.attr('data-add-parent-split-words'))) {
                                new SplitText(thisEl, {type: "words", wordsClass: "parent-block-anim"});
                            }
                            const splitTypingText = new SplitText(thisEl, {type: "words", wordsClass: "wrapped-words"});
                            //Add delay each word
                            if (stringToBoolean(thisEl.attr('data-delay-each-words'))) {
                                $(splitTypingText.words).each(function (inx, el) {
                                    let index = inx + 1,
                                        delayEachWord = thisEl.attr('data-delay-word-' + index),
                                        durationEachWord = thisEl.attr('data-duration-word-' + index);
                                    delayEachWord ? objToVars['delay'] = Number(delayEachWord) : null;
                                    durationEachWord ? objToVars['duration'] = Number(durationEachWord) : null;
                                    gsap.timeline(objScrollTrigger).fromTo(el, objFromVars, objToVars);
                                });
                            } else {
                                //Default animate
                                gsap.timeline(objScrollTrigger).fromTo(thisEl, objFromVars, objToVars);
                            }
                        } else {
                            gsap.timeline(objScrollTrigger).fromTo(thisEl, objFromVars, objToVars);
                        }
                    });
                }
            });
        }
}
export default animTransform;
